import React from "react";
import memoize from "memoize-weak";
import Input from "./Input";
import Select from "./Select";
import { range } from "lib/utils/socialtravel";

const addLeadingZero = (number) => (number < 10 ? `0${number}` : number);

const getDayOptions = () => range(1, 31, true).map((j) => [j, j]);
const getMonthOptions = () =>
  range(1, 12, true).map((j) => [
    j,
    moment()
      .set("month", j - 1)
      .format("MMMM"),
  ]);
const getYearOptions = () => range(1900, moment().year(), true).map((j) => [j, j]);
const getDateOptions = memoize((locale) => ({
  day: getDayOptions(),
  month: getMonthOptions(),
  year: getYearOptions(),
}));

export default class DateSelectControl extends React.PureComponent {
  constructor(...args) {
    super(...args);
    const { value, initialYear = 1980, initialMonth = null, initialDay = null } = this.props;
    const [year, month, day] = value ? value.split("-").map((v) => +v) : [initialYear, initialMonth, initialDay];
    this.state = { day, month, year };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      const { initialYear = 1980, initialMonth = null, initialDay = null } = nextProps;
      const [year, month, day] = nextProps.value
        ? nextProps.value.split("-").map((v) => +v)
        : [initialYear, initialMonth, initialDay];
      this.setState({ day, month, year });
    }
  }

  handleChange({ day, month, year }) {
    const { onFocus, onChange, onBlur } = this.props;
    this.setState({ day, month, year });
    onFocus && onFocus();
    if (day && month && year) {
      onChange && onChange(moment({ day: day, month: month - 1, year }).format(moment.RUBY_DATE_FORMAT));
    } else {
      onChange && onChange(null);
    }
    onBlur && onBlur();
  }

  render() {
    const { id } = this.props;
    const { year, month, day } = this.state;
    const options = getDateOptions(I18n.locale);

    return (
      <span className="u-whiteSpaceNowrap c-DateSelectControl">
        <Select
          search
          id={id}
          value={day || ""}
          onChange={(day) => this.handleChange({ day, month, year })}
          options={options.day}
          placeholder={I18n.t("base.date.day")}
          includeBlank
          className="c-DateSelectControl-day u-marginRight"
        />
        <Select
          search
          value={month || ""}
          onChange={(month) => this.handleChange({ day, month, year })}
          options={options.month}
          placeholder={I18n.t("base.date.month")}
          includeBlank
          className="c-DateSelectControl-month u-marginRight"
        />
        <Select
          search
          value={year || ""}
          onChange={(year) => this.handleChange({ day, month, year })}
          options={options.year}
          placeholder={I18n.t("base.date.year")}
          includeBlank
          className="c-DateSelectControl-year"
        />
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/DateSelect.jsx